import '@vfde-brix/help-and-support-contact/dist/styles.css';
import '@vfde-brix/helpful/dist/styles.css';
import '@vfde-brix/feedback/dist/styles.css';
import '@vfde-brix/contact-us/dist/styles.css';
import '@vfde-brix/button/dist/styles.css';
import '@vfde-brix/notification/dist/styles.css';

import { createHelpAndSupportContactComponent } from '@vfde-brix/help-and-support-contact';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

const elements = document.getElementsByClassName('brix-HelpAndSupportContact');

for (let i = 0, x = elements.length; i < x; i += 1) {

    // traversing one up to get the container element
    // @TODO add this casting to read dom -> does container element has already the class brix-HelpAndSupportContact?
    const containerElement = elements[i].parentNode as HTMLElement;

    createHelpAndSupportContactComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);

}
